import React, { useState } from "react";
import Avatar from "@mui/material/Avatar";
import { Container, Typography, Grid, Box,Button } from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";
import LogoutIcon from "@mui/icons-material/Logout";
import HistoryIcon from "@mui/icons-material/History";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import DinnerDiningIcon from "@mui/icons-material/DinnerDining";
import { useSnackbar } from "notistack";
import { Link, useNavigate } from "react-router-dom";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Button as MUIButton,
  } from "@mui/material";
const Myprofile = ({ user,onLogout }) => {
    const { enqueueSnackbar } = useSnackbar();
    const navigate = useNavigate();
    const [logoutConfirmationOpen, setLogoutConfirmationOpen] = useState(false);
  
    const handleOpenLogoutConfirmation = () => {
      setLogoutConfirmationOpen(true);
    };
  
    const handleCloseLogoutConfirmation = () => {
      setLogoutConfirmationOpen(false);
    };
  
    const handleConfirmLogout = () => {
        onLogout();
      setLogoutConfirmationOpen(false);
      enqueueSnackbar("You are logged out. Please log in to continue", {
        variant: "warning",
      });
      navigate("/login");
      setOpen(false);
    };
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => {
      setOpen(true);
    };
    const handleClose = () => {
      setOpen(false);
    };
  return (
    <>
      <React.Fragment>
        <Container>
          {user ? (
            <Typography
              sx={{
                marginLeft: "auto",
                display: "flex",
                cursor: "pointer",
                mt: 15,
                borderBottomWidth: "1px", // Adjust the width as needed
                borderBottomColor: "black", // Set the color of the border
                borderBottomStyle: "solid",
                paddingBottom: "25px",
              }}
            >
              {" "}
              <Avatar
                alt={user.username}
                src="/static/images/avatar/1.jpg"
                sx={{
                  marginRight: 2,
                  bgcolor: "#a33307",
                  mt: 0.9,
                  width: 80,
                  height: 80,
                }}
              />
              <Typography
                sx={{
                  color: "black",
                  fontSize: 25,
                  xs: { display: "block" },
                }}
              >
                Hello, <br />
                <span
                  style={{
                    fontSize: 30,
                    color: "#a33307",
                    fontWeight: "bold",
                  }}
                >
                  {user.username}
                </span>
              </Typography>
            </Typography>
          ) : null}
          {user?(<Grid container spacing={2}>
            <Grid item lg={4}>
              <Box
                sx={{
                  padding: 5,borderRight: "1px solid black", 
                  paddingLeft: "100px"
                }}
              >
                <Typography
                  sx={{
                    fontSize: 17,
                    fontWeight: 700,
                    display: "flex",
                    mt: 4,
                    cursor: "pointer",
                  }}
                >
                  {" "}
                  <HistoryIcon sx={{ color: "#a33307",paddingRight:1  }} /> Order History
                </Typography>
                <Typography
                  sx={{
                    fontSize: 17,
                    fontWeight: 700,
                    display: "flex",
                    mt: 4,
                    cursor: "pointer",
                  }}
                >
                  {" "}
                  <SettingsIcon sx={{ color: "#a33307",paddingRight:1 }} /> Settings{" "}
                </Typography>
                <Typography
                  sx={{
                    fontSize: 17,
                    fontWeight: 700,
                    display: "flex",
                    mt: 4,
                    cursor: "pointer",
                  }}
                  onClick={handleOpenLogoutConfirmation}
                >
                  {" "}
                  <LogoutIcon sx={{ color: "#a33307",paddingRight:1  }} /> Logout
                </Typography>
              </Box>
            </Grid>
            <Grid item lg={8}>
              <Box sx={{ padding: 5,paddingTop:8}}>
                
                <Typography ><span style={{fontSize:18,fontWeight:"bold",mt:1}}>Username:</span> {user.username}</Typography>
                
                <Typography sx={{mt:3}} ><span style={{fontSize:18,fontWeight:"bold",}}>First Name: </span>{user.firstname} </Typography>
                <Typography sx={{mt:3}} ><span style={{fontSize:18,fontWeight:"bold",}}>Last Name:</span>  {user.lastname}</Typography>
                <Typography sx={{mt:3}} ><span style={{fontSize:18,fontWeight:"bold",}}>Email:</span> {user.email}</Typography>
                <Typography sx={{mt:3}} ><span style={{fontSize:18,fontWeight:"bold",}}>Address:</span> {user.address}</Typography>
              </Box>{" "}
            </Grid>
          </Grid>):null}
          
        </Container>
        <Dialog
        open={logoutConfirmationOpen}
        onClose={handleCloseLogoutConfirmation}
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle>Logout Confirmation</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to logout?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseLogoutConfirmation} color="primary">
            No
          </Button>
          <Button onClick={handleConfirmLogout} color="primary">
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      </React.Fragment>
    </>
  );
};

export default Myprofile;
